// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SleepSchoolSelf = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx={40} cy={40} r={40} fill="#BE4070" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m60.348 43.952-6-6a1.2 1.2 0 0 0-.848-.352H40.9v-3.3h12.6a1.2 1.2 0 0 0 1.2-1.2v-12a1.2 1.2 0 0 0-1.2-1.2H40.9v-2.4a1.2 1.2 0 0 0-2.4 0v2.4h-12a1.2 1.2 0 0 0-.849.352l-6 6a1.2 1.2 0 0 0 0 1.696l6 6a1.2 1.2 0 0 0 .849.352h12v3.3h-12a1.2 1.2 0 0 0-1.2 1.2v12a1.2 1.2 0 0 0 1.2 1.2h12v9.3h-4.8a1.2 1.2 0 0 0 0 2.4h12a1.2 1.2 0 0 0 0-2.4h-4.8V52h12.6a1.2 1.2 0 0 0 .848-.352l6-6a1.2 1.2 0 0 0 0-1.696Z"
			fill="#000"
		/>
	</svg>
);
export default SleepSchoolSelf;
